import Vue from 'vue';
import Vuex from 'vuex';
// import modules from './modules';
import report from './report.module';
import auth from './auth.module';
import notification from './notification.module';
import messenger from './messenger.module';
import tmz from './tmz.module';
import dzo from './dzo.module';
import profile from './profile.module';

import axios from 'axios';
import { router } from '@/router';

Vue.use(Vuex);
// Axios globals
axios.defaults.baseURL = process.env.VUE_APP_ROOT_URL;

let jwt = localStorage.getItem('token');

const emoji = ['👍🏻', '👯‍', '😸', '🏄', '🔥', '🎉', '😄', '🦁'];
function randomEmoji() {
	let random = Math.floor(Math.random() * emoji.length);
	return emoji[random];
}

// Measuring request - response time
axios.interceptors.request.use(x => {
	// to avoid overwriting if another interceptor
	// already defined the same object (meta)
	x.meta = x.meta || {};
	x.meta.requestStartedAt = new Date().getTime();
	return x;
});

axios.interceptors.response.use(
	x => {
		console.log(
			`🚀Execution time for: ${x.config.url} - ${new Date().getTime() -
				x.config.meta.requestStartedAt} ms`
		);
		return x;
	},
	// Handle 4xx & 5xx responses
	x => {
		console.error(
			`Execution time for: ${x.config.url} - ${new Date().getTime() -
				x.config.meta.requestStartedAt} ms`
		);
		throw x;
	}
);

// Request time sent
axios.interceptors.request.use(
	config => {
		let jwt = localStorage.getItem('token');
		config.headers.Authorization = 'JWT ' + jwt;

		let currentTime = new Date();
		let h = currentTime.getHours();
		let m = currentTime.getMinutes();
		let s = currentTime.getSeconds();

		console.info(
			`${randomEmoji()} ${config.method.toUpperCase()} request sent to API: ${
				config.url
			} at ${h}:${m}:${s}`
		);
		return config;
	},
	error => {
		return Promise.reject(error);
	}
);

axios.interceptors.response.use(null, function(error) {
	if (error.response.status === 401) {
		router.push({
			name: 'logout',
		});
	}

	return Promise.reject(error);
});

export default new Vuex.Store({
	// modules,
	modules: {
		auth,
		report,
		notification,
		messenger,
		tmz,
		dzo,
		profile,
	},
});
